/* vito-pet-counter.js
   Zweck:  Haelt die PET-Zahl bei Variantenwechsel aktuell.
   Basis:  Concept 6.0.0 — Event "variant:change" auf dem Produktformular,
           Detail { variant }. Serverseitig ist der Startwert schon gerendert,
           dieses Skript aktualisiert nur.
   Regel:  liest ausschliesslich die eigene Datenkarte, faengt keine Theme-Events ab.
*/

class VitoPetCounter extends HTMLElement {
  connectedCallback() {
    this.formId = this.getAttribute('form') || '';
    this.map = this.parse('data-map', {});
    this.i18n = this.parse('data-i18n', {});
    this.numEl = this.querySelector('[data-vito-pet-num]');
    this.textEl = this.querySelector('[data-vito-pet-text]');

    this.onVariantChange = this.onVariantChange.bind(this);
    this.target = this.form || document;
    this.target.addEventListener('variant:change', this.onVariantChange);
  }

  disconnectedCallback() {
    if (this.target) this.target.removeEventListener('variant:change', this.onVariantChange);
  }

  parse(attr, fallback) {
    try {
      var v = JSON.parse(this.getAttribute(attr) || '');
      return v == null ? fallback : v;
    } catch (e) { return fallback; }
  }

  get form() {
    return this.formId && document.forms[this.formId] ? document.forms[this.formId] : null;
  }

  onVariantChange(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    this.apply(String(variant.id), variant.title);
  }

  apply(variantId, fallbackSize) {
    var entry = this.map[variantId];
    var n = entry && entry.n ? Number(entry.n) : 0;
    var size = (entry && entry.size) || fallbackSize || '';

    if (this.numEl) {
      var changed = this.numEl.textContent.trim() !== String(n);
      this.numEl.textContent = n > 0 ? n : '';
      if (changed && n > 0) {
        this.numEl.classList.remove('is-updated');
        /* Reflow erzwingen, damit die Animation erneut startet */
        void this.numEl.offsetWidth;
        this.numEl.classList.add('is-updated');
      }
    }

    if (this.textEl) {
      this.textEl.textContent = n > 0
        ? this.t('reused', { size: size })
        : this.t('unknown');
    }

    /* Ohne Zahl verschwindet die Zeile ganz — keine halbe Aussage. */
    this.hidden = n <= 0;
  }

  t(key, rep) {
    var raw = this.i18n[key];
    if (raw == null) return '';
    if (rep) {
      Object.keys(rep).forEach(function (k) {
        raw = raw.split('{{ ' + k + ' }}').join(rep[k]).split('{{' + k + '}}').join(rep[k]);
      });
    }
    return raw;
  }
}

if (!customElements.get('vito-pet-counter')) {
  customElements.define('vito-pet-counter', VitoPetCounter);
}
